module.exports = __webpack_public_path__ + "static/img/deal_9.f6f6e761.png";